export const FINANCIAL_ROLES = ['OWNER', 'ADMIN'];

export function normalizeRole(role) {
  return String(role || '').toUpperCase();
}

export function canAccessFinancialModules(role) {
  return FINANCIAL_ROLES.includes(normalizeRole(role));
}

export function roleLabel(role) {
  const normalized = normalizeRole(role);
  if (normalized === 'LABORER') return 'Worker';
  return normalized || 'User';
}
